import React, {Component} from 'react';
import {TopAlertOstrzezenie} from "../../../../../../componentsTopsa/alerty/TopAlerts";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";
import FakturyBiletyService from "../../../fakturyBilety/FakturyBiletyService";

class BKWystawioneDokumenty extends Component {

    state = {};

    renderPobierz = (cell, row) => {
        if (row.typDok.indexOf('Faktura') > -1)
            if(Boolean(this.props.bilet.idBi))
            return (
                <a href={FakturyBiletyService.pobierzFaktureNaDanyBiletJednorazowy(this.props.bilet.idBi, row.tab, row.symNum)} className={'btn btn-default'}>
                    <i className={'fa fa-download'}></i> Pobierz
                </a>
            )
    }


    render() {

        const {dokumenty} = this.props;

        return (
            <div>
                {
                    Boolean(dokumenty) &&
                    dokumenty.length > 0 ?
                        <div>
                            <BootstrapTable data={dokumenty}
                                            hover
                            >
                                <TableHeaderColumn dataField='numerfaktury' isKey hidden={false}
                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                >Numer faktury</TableHeaderColumn>
                                <TableHeaderColumn dataField='typDok'
                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                >Typ dokumentu</TableHeaderColumn>
                                <TableHeaderColumn dataField='symNum'
                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                >Symbol</TableHeaderColumn>
                                <TableHeaderColumn dataField='tab'
                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                >Tab</TableHeaderColumn>
                                <TableHeaderColumn dataField='nipParagon'
                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                >NIP paragon</TableHeaderColumn>
                                <TableHeaderColumn dataField='nipRozl'
                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                >NIP rozl</TableHeaderColumn>
                                <TableHeaderColumn dataField='numerfaktury'
                                                   thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                                   dataFormat={this.renderPobierz}
                                >Pobierz</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        :
                        <TopAlertOstrzezenie text={'Brak wystawionych dokumentów w systemie na ten bilet'}/>
                }
            </div>
        );
    }
}

export default BKWystawioneDokumenty;


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/bilety_kod_z_paragonu_components/BKWystawioneDokumenty.js